/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.BlockTypes {
    "use strict";

    export class BlockTypesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        durationIncrements;
        $scope;
        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            timeoutService: angular.ITimeoutService,
            durationIncrements,
            scope: angular.IScope
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.$scope = scope;
            //this.baseEndpoint = appSettings.API_ENDPOINTS.blockType + '/' + this.selectedSection.model.id + '/Locations';
            this.baseEndpoint = appSettings.API_ENDPOINTS.blockType;
            this.sectionTemplatePath = "app/plugins/blockTypes/sectionViews/";
            this.durationIncrements = durationIncrements;
            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            this.buildCrudSecurityKeys(this.securityKeys.DATA_BLOCKTYPE_TAB_MAIN);
            this.entityType = 'BlockType';
            this.initializeSections();
            if (this.sections.length > 0) {
                (<BlockTypes.MainSection>this.sections[0]).timeoutService = timeoutService;
            }
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_BLOCKTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new MainSection(0,
                        "SECTION_BLOCK_TYPES_MAIN",
                        "main.html",
                        true,
                        false,
                        this.appSettings.API_ENDPOINTS.blockType,
                        "",
                        this.loggingService,
                        this.dataService,
                        this.durationIncrements,
                        this.identityService,
                        Meevo.Model.NounEnum.BlockTypeMain,
                        this.$scope,
                        this.appSettings,
                        this.securityKeys.DATA_BLOCKTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
                );
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.BlockType>();
            model.displayName = undefined;
        }
    }
}